import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { DiscountOfferMiniEntity } from '../../domain/entities/DiscountOfferMiniEntity'
import type { DiscountAdminDto } from '@/backend/market'


export class DiscountOfferMiniModel extends DiscountOfferMiniEntity {
  constructor(dataDto: DiscountAdminDto) {
    super()
    mapEntityProperties<DiscountOfferMiniEntity>(this, dataDto)
  }
}
